import React from 'react';
import { useTranslation } from 'react-i18next';
import Image from 'next/future/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentAlt } from '@fortawesome/pro-regular-svg-icons/faCommentAlt';
import { faHeart } from '@fortawesome/pro-regular-svg-icons/faHeart';
import { Card } from '@platzi/ui';
import { imageLoader } from 'src/utils/imageOptimizer';
import styles from './TutorialsCard.module.sass';

export const TutorialsCard = (props) => {
  const { t } = useTranslation();

  return (
    <Card isDark customClass={styles.TutorialsCard}>
      <a href={props.url}>
        <div className={styles.Content}>
          <h4>{props.title}</h4>
          <div className={styles.Info}>
            <Image
              loader={imageLoader}
              src={props.authorData.avatar}
              alt={props.authorData.public_name}
              width={39}
              height={39}
            />
            <div>
              <p>{props.authorData.public_name}</p>
              <span>
                {t(`escuela.tutorialsCard.time-${props.createdAt.time_type}`, { count: props.createdAt.time })}
              </span>
            </div>
          </div>
        </div>
        <div className={styles.Footer}>
          <span>
            <FontAwesomeIcon icon={faHeart} /> {props.likes}
          </span>
          <div>•</div>
          <span>
            <FontAwesomeIcon icon={faCommentAlt} /> {props.comments}
          </span>
        </div>
      </a>
    </Card>
  );
};
